export const getters = {
    getPosVenda: state => state.posVenda,
    getPosVendas: state => state.posVendas,
    getModalCadastroPosVenda: state => state.modalCadastroPosVenda,
    getModalVisualizarPosVenda: state => state.modalVisualizarPosVenda,
    getModalExcluirPosVenda: state => state.modalExcluirPosVenda,
    getModalPesquisarPosVenda: state => state.modalPesquisarPosVenda,
    getModalFinalizarPosVenda: state => state.modalFinalizarPosVenda,
}

export default {}